export default __webpack_public_path__ + "static/media/postgres.ae92b576.svg";